module.exports = __webpack_public_path__ + "aadfe7d9cf984e0012099f75b28bccf1.fbx";